import { featureFlagSlugs } from '@/constants/featureFlagSlugs';
import { newFeatures } from '@/constants/newFeatures';
import { uselocalStorageGetterSetter } from '@/composables/uselocalStorageGetterSetter';

export default defineNuxtRouteMiddleware(async () => {
  const useFeatureFlagsStore = useFeatureFlags();

  await useFeatureFlagsStore.fetchFlagByName(
    featureFlagSlugs.transportFilterByBundles
  );

  const { setObject, getNewFeaturesObject, setNewFeaturesObject } =
    uselocalStorageGetterSetter();

  const filterByBundlesIsNewObj = {
    [newFeatures.isFilterByJobTypeNew]: true,
  };

  const newFeaturesObj = getNewFeaturesObject();

  if (!newFeaturesObj) {
    setObject('NEW_FEATURES', filterByBundlesIsNewObj);
  }
});
